import { useQuery } from 'react-query';

import { OFFER_KEY, OfferInfoRequest, getOfferInfo } from '@utils/backend-api/offer';
import { OfferOption } from '@utils/backend-api/subscribe';

const useOffer = (params: OfferInfoRequest) => {
  const { data, isLoading } = useQuery<OfferOption>(OFFER_KEY, () => getOfferInfo(params), {});
  return { data, isLoading };
};

export default useOffer;
